import React from 'react';

const SIZES = {
  list: 32,
  card: 56,
  detail: 112,
  form: 72,
};

export default function NewsAvatar({ src, size = 'card', alt = '', className = '', style = {} }) {
  if (!src) return null;
  const px = typeof size === 'number' ? size : (SIZES[size] || SIZES.card);
  return (
    <img
      src={src}
      alt={alt}
      className={`rounded-full object-cover bg-gray-200 dark:bg-gray-700 shrink-0 ${className}`}
      style={{ width: px, height: px, ...style }}
    />
  );
}
